import {ContentWithLevel} from "@k/js/delme_globals";
import {useFooterStore} from "~/store/FooterStore";
import {useShopInfos} from "~/store/shopInfosStore";
import {useRequestURL} from "#app";

export const loadWebsitelinks = async (language:string) => {
    const contentArray = [
        new ContentWithLevel("agbs", 1),
        new ContentWithLevel("faq_neu", 1),
        new ContentWithLevel("lieferzeit_neu", 1),
        new ContentWithLevel("datenschutzerklaerung", 1),
    ];
    const shopInfo = useShopInfos();
    const requestURL = useRequestURL();                  // <– neu
    const currentDomain = requestURL.origin;

    if(language==='us' || language==='ca'){
        language = 'en';
    }

    const body = {
        land: shopInfo.getShopLand,
        sprache: language,
        sportWebInt: "",
        targetContents: contentArray,
        product: ""
    };
    fetch(currentDomain+"/konfigurator_php/actionmodul/linkErsteller.php", {
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        method: "POST"
    }).then(response => response.json()).then(data =>{
        const footerStore = useFooterStore();
        console.log(data);
        footerStore.SET_WEBSITE_LINKS(data);
    });
}
